import type { ButtonProps } from '@base-ui/react';

import { Button as BaseButton } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { Spinner } from '../Spinner/Spinner';
import { buttonLinkStyle } from './ButtonLink.css';
import { linkStyle } from './Link.css';

type Props = ButtonProps & {
  loading?: boolean;
};

export const ButtonLink = ({ children, disabled, loading = false, ...delegated }: Props) => {
  return (
    <BaseButton
      {...delegated}
      className={clsxs(linkStyle, buttonLinkStyle, delegated.className)}
      disabled={disabled || loading}
      focusableWhenDisabled={loading}
    >
      {loading && <Spinner size="inline" />}
      {children}
    </BaseButton>
  );
};
